import React, { useEffect } from "react";
import { Form, Input, Select } from "antd";
import { useSelector } from "react-redux";
import { INTL_CALLBACK_URL_PATTERN } from "../../../../utils/intlSoft";
import styles from "./index.modules.less";

const IntlAddForm = ({ initialValues, onFormInstanceReady }) => {
  const { config } = useSelector((state) => state);
  const [form] = Form.useForm();

  useEffect(() => {
    onFormInstanceReady(form);
  }, [form, onFormInstanceReady]);

  const renderRow = (label, required, field, topAlign = false) => (
    <div className={topAlign ? styles.rowTop : styles.row}>
      <div className={topAlign ? styles.labelTop : styles.label}>
        {required ? <span className={styles.required}>*</span> : null}
        {label}:
      </div>
      <div className={styles.control}>{field}</div>
    </div>
  );

  return (
    <Form
      form={form}
      name="intl_add_soft_form"
      className={styles.form}
      initialValues={{
        channel: 1,
        ...initialValues,
      }}
      requiredMark={false}
    >
      {renderRow(
        "软件名称",
        true,
        <Form.Item
          name="app_name"
          rules={[
            { required: true, message: "请输入软件名称" },
            { max: 20, message: "不超过20个英文字符" },
          ]}
        >
          <Input
            placeholder="请输入默认名称（不超过20个英文字符）"
            className={styles.input}
            bordered={false}
          />
        </Form.Item>
      )}

      {renderRow(
        "回调地址",
        true,
        <Form.Item
          name="callback_url"
          normalize={(value) => value && value.trim()}
          rules={[
            { required: true, message: "请输入回调地址" },
            { pattern: INTL_CALLBACK_URL_PATTERN, message: "请输入http或者https地址" },
          ]}
        >
          <Input placeholder="请输入http或者https地址" className={styles.input} bordered={false} />
        </Form.Item>
      )}

      {renderRow(
        "邮箱",
        true,
        <Form.Item
          name="app_email"
          rules={[
            { required: true, message: "请填写邮箱" },
            { type: "email", message: "邮箱格式不正确" },
          ]}
        >
          <Input placeholder="作为主要的联系方式" className={styles.input} bordered={false} />
        </Form.Item>
      )}

      {renderRow(
        "X (Twitter)",
        false,
        <Form.Item name="contact_x">
          <Input placeholder="请输入X平台账号" className={styles.input} bordered={false} />
        </Form.Item>
      )}

      {renderRow(
        "Telegram",
        false,
        <Form.Item name="contact_telegram">
          <Input placeholder="请输入TG群组或账号" className={styles.input} bordered={false} />
        </Form.Item>
      )}

      {renderRow(
        "Discord",
        false,
        <Form.Item name="contact_discord">
          <Input placeholder="请输入Discord邀请链接" className={styles.input} bordered={false} />
        </Form.Item>
      )}

      <div className={styles.row}>
        <div className={styles.label}>
          <span className={styles.required}>*</span>
          软件环境:
        </div>
        <div className={styles.controlFixed}>
          <Form.Item name="channel" rules={[{ required: true, message: "请选择软件环境" }]}>
            <Select
              className={styles.selectEnv}
              options={[
                { value: 1, label: "正式" },
                { value: 0, label: "测试" },
              ]}
            />
          </Form.Item>
        </div>
      </div>

      {renderRow(
        "软件类型",
        true,
        <Form.Item name="app_cate_id" rules={[{ required: true, message: "请选择软件类型" }]}>
          <Select
            className={styles.selectType}
            placeholder="请选择软件类型！"
            options={(config?.soft_cate || []).map((item) => ({
              value: item.id,
              label: item.name,
            }))}
          />
        </Form.Item>
      )}

      <div className={styles.divider}>
        <div className={styles.dividerLine} />
        <span className={styles.dividerText}>用户将会通过以下方式联系您</span>
        <div className={styles.dividerLine} />
      </div>

      {renderRow(
        "备注",
        false,
        <Form.Item name="remark">
          <Input.TextArea rows={4} className={styles.textarea} bordered={false} />
        </Form.Item>,
        true
      )}
    </Form>
  );
};

export default IntlAddForm;
